import { Dialog, TextField } from "@mui/material";
import { useState } from "react";
import DialogContentSelectGeneric from "./DialogsContents/DialogContentGeneric";
import { defValueConsultor, IPesquisaConsultores } from "../../types/api/comercial/pesquisar-consultores";

export default function SelectConsultor({
    value,
    required = false,
    error = false,
    errorMessage = undefined,
    possuiBtnLimpar = false,
    onChange
}: SelectSimpleApiQueryProps) {

    const [openModal, setOpenModal] = useState(false);

    const handleClose = () => setOpenModal(false);

    const inputLabel = value ? `${value.nome}` : "";

    return (
        <>
            <TextField
                {...{ required, error }}
                label={`Consultor`}
                variant="outlined"
                fullWidth
                onClick={() => setOpenModal(true)}
                onKeyDown={(e) => {
                    if (e.key === "Enter") {
                        setOpenModal(true);
                    }
                }}
                slotProps={{
                    input: { readOnly: true }
                }}
                value={inputLabel}
                helperText={error ? errorMessage : ""}
            />

            {
                openModal &&
                <Dialog
                    fullWidth
                    maxWidth="sm"
                    open={openModal}
                    onClose={handleClose}
                >
                    <DialogContentSelectGeneric
                        {...{ handleClose, possuiBtnLimpar }}
                        title="Selecionar consultor"
                        queryPath="/comercial/configuracoes/pesquisar-consultores"
                        getItemKey={(item) => item.id}
                        getItemLabel={(item) => `${item.nome}`}
                        defaultValue={value || defValueConsultor}
                        onChange={(value) => {
                            onChange(value as IPesquisaConsultores);
                            handleClose();
                        }}
                    />
                </Dialog>
            }
        </>
    );
}

interface SelectSimpleApiQueryProps {
    value: IPesquisaConsultores | null | undefined;
    onChange: (arg: IPesquisaConsultores | null) => void;
    required?: boolean;
    error?: boolean;
    errorMessage?: string | undefined;
    possuiBtnLimpar?: boolean;
}